/**
 * /frontend/src/features/analytics/components/abandonment/AbandonmentTrendChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import DualAxisLineChart from '../charts/DualAxisLineChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Abandonment trend with revenue loss (dual axis).
 * @param {{data:Array<{label:string,abandonmentCount:number,estimatedRevenueLoss:number}>}} props
 * @returns {JSX.Element}
 */
const AbandonmentTrendChart = ({ data }) => {
  const lines = useMemo(() => ([
    { key: 'abandonmentCount', label: 'Abandonments', color: CHART_COLORS.danger },
    { key: 'estimatedRevenueLoss', label: 'Revenue loss (₹)', color: CHART_COLORS.warning, yAxisId: 'right' }
  ]), []);
  return (
    <ChartContainer title="Abandonment Trend" subtitle="Count and revenue loss over time">
      <DualAxisLineChart data={data} xKey="label" lines={lines} rightAxisKey="estimatedRevenueLoss" />
    </ChartContainer>
  );
};

export default AbandonmentTrendChart;

